import { useMemo } from 'react';
import styles from './initials-icon.module.css';
import { Avatar, ConfigProvider } from 'antd';

interface Props {
  fullName: string;
}

const InitialsIcon = ({ fullName }: Props): JSX.Element => {
  const initials = useMemo(() => {
    const splicedName = fullName.split(' ');

    return splicedName.reduce((accumulator, currentValue) => {
      return accumulator.charAt(0) + currentValue.charAt(0).toUpperCase();
    });
  }, [fullName]);

  return (
    <ConfigProvider
      theme={{
        token: {
          controlHeight: 24,
        },
      }}
    >
      <Avatar className={styles.avatar} data-testid="initialsIconAvatarId">
        <span>{initials}</span>
      </Avatar>
    </ConfigProvider>
  );
};

export default InitialsIcon;
